import { atom } from 'jotai';

// Bump to request a canvas recenter; an atom so distant components can trigger it too.
export const workflowExecutionRecenterNonceAtom = atom(0);
